module.exports = __webpack_public_path__ + "static/img/SC9.6d497d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/SC9.jpg
// module id = oCeE
// module chunks = 0